export { default } from './ManagePayment';
